// Playtest speed: an admin-only multiplier on their own account's game clock,
// for trying late-game content without hours of play. The server runs that
// many hunt ticks per real tick (more kills, same per-kill values), and moves
// egg and Boss Ladder timers that much faster. Boosts, the Aura Charm, quests
// and the season pass keep real time.
//
// Quarantine: setting it above ×1 makes the account a playtest account for
// good (TrainerDTO.playtest). Everything it holds is admin-flagged (never
// listed, sold to the Exchange, gifted or paid to other players), and it is
// left off boards, Records, the Hall of Legends, catch broadcasts, the Arena,
// Halls, Guild War and tournaments. Turning it back to ×1 stops the speed only.

export const PLAYTEST = {
  /** Highest multiplier. */
  max: 1000,
  /** Buttons on the admin page. */
  presets: [1, 10, 100, 1000] as readonly number[],
  /** Wall-clock budget per world tick for every sped-up hunt together; past it the speed falls short that tick. */
  budgetMs: 30,
} as const;

/** A multiplier from a client message: a whole number 1..max, or null when not a number. */
export function parseSpeed(v: unknown): number | null {
  const n = Math.floor(Number(v));
  if (!Number.isFinite(n)) return null;
  return Math.max(1, Math.min(PLAYTEST.max, n));
}

/** Hunt events worth sending from the extra (sped-up) ticks; hits, spawns and the like are dropped. */
export const SPEED_KEEP = new Set(['catch', 'hatch', 'clevel', 'levelup', 'rest', 'retreat', 'move', 'weekcatch', 'shrine']);
